var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Video@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Video",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 6.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.79471961,-7.25088203e-17 L11.9552804,7.25088203e-17 C12.5793435,-4.21297127e-17 12.8056439,0.0649779267 13.033792,0.186992889 C13.2619401,0.309007852 13.4409921,0.488059851 13.5630071,0.716207995 C13.6850221,0.94435614 13.75,1.1706565 13.75,1.79471961 L13.75,9.20528039 C13.75,9.8293435 13.6850221,10.0556439 13.5630071,10.283792 C13.4409921,10.5119401 13.2619401,10.6909921 13.033792,10.8130071 C12.8056439,10.9350221 12.5793435,11 11.9552804,11 L1.79471961,11 C1.1706565,11 0.94435614,10.9350221 0.716207995,10.8130071 C0.488059851,10.6909921 0.309007852,10.5119401 0.186992889,10.283792 C0.0649779267,10.0556439 9.39485689e-17,9.8293435 -1.61693481e-16,9.20528039 L4.83392135e-17,1.79471961 C-2.80864751e-17,1.1706565 0.0649779267,0.94435614 0.186992889,0.716207995 C0.309007852,0.488059851 0.488059851,0.309007852 0.716207995,0.186992889 C0.94435614,0.0649779267 1.1706565,4.21297127e-17 1.79471961,-7.25088203e-17 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2599167,8.63041667 L19.6304167,9.81475 C19.8435282,9.92114296 20.096526,9.90964554 20.299109,9.78436146 C20.5016921,9.65907738 20.625,9.43785985 20.625,9.19966667 L20.625,1.80033333 C20.625,1.56214015 20.5016921,1.34092262 20.299109,1.21563854 C20.096526,1.09035446 19.8435282,1.07885704 19.6304167,1.18525 L17.2599167,2.36958333 C16.7940465,2.60259636 16.4998441,3.07885646 16.4999999,3.59975 L16.4999999,7.40025 C16.4998441,7.92114354 16.7940465,8.39740364 17.2599167,8.63041667 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/Video-call.cbfea20d5529998765d7fa5c1756f82d.svg";
export { ForwardRef as ReactComponent };